import React from "react";
import {
  Box,
  BoxProps,
  Button,
  Theme,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import LockIcon from "@icons/myicons/lock.svg?react";
import { Tooltip } from "@components";
import { usePremiumFeaturesModal } from "@components/PremiumFeaturesModal";
import { useMyself } from "@api";

export const TooltipContent = ({
  onUpgradeClick,
}: {
  onUpgradeClick?: () => void;
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isLessSm = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
      gap={2.5}
    >
      <Typography
        variant="body3"
        noWrap={!isLessSm}
        fontWeight={400}
        color="textPrimary"
      >
        {t("onlyForProBlock.title")}
      </Typography>
      <Box alignSelf="center" display="flex" alignItems="center">
        <Button
          variant="primary"
          color="upgrade"
          size="small"
          onClick={onUpgradeClick}
          sx={{
            color: `${theme.palette.button.upgradeButton.textOnDefault} !important`,
          }}
        >
          {t("onlyForProBlock.updateToPro")}
        </Button>
      </Box>
    </Box>
  );
};

type Props = {
  children: React.ReactNode;
  tooltip?: React.ReactNode;
  iconColor?: string;
  isLockIconShown?: boolean;
} & BoxProps;

export const NonProContainer = ({
  children,
  tooltip,
  iconColor,
  isLockIconShown,
  ...rest
}: Props) => {
  const { data: myself } = useMyself();
  const isLessSm = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );
  const isLessMd = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("md")
  );
  const { openPremiumModal, premiumModal } = usePremiumFeaturesModal();

  if (myself?.isUserPro || myself?.isUserPlus)
    return <Box {...rest}>{children}</Box>;

  return (
    <>
      <Box {...rest}>
        <Tooltip
          text={tooltip ?? <TooltipContent onUpgradeClick={openPremiumModal} />}
          placement="top"
          maxWidth={isLessSm ? "200px" : "none"}
          openOnClick={isLessMd}
        >
          <Box id="tooltip-block">
            {isLockIconShown ? (
              <Box display="flex" alignItems="center" gap={1}>
                <LockIcon color={iconColor} />
                {children}
              </Box>
            ) : (
              children
            )}
          </Box>
        </Tooltip>
      </Box>
      {premiumModal}
    </>
  );
};
